<template>
  <v-dialog v-model="visible" persistent max-width="500">
    <v-card
      class="pa-4 text-center k-card-border card"
      color="#1B1F23"
      style="border-color: #1b1f23"
    >
      <v-card-title>
        <h2 class="ui-h2 text-white">Disclaimer</h2>
      </v-card-title>
      <v-card-text>
        This tool does not collect data from users. By clicking “Agree”, you accept this
        message and the use of this tool.
      </v-card-text>

      <div class="d-flex flex-wrap mx-auto text-center ga-2 pa-4">
        <v-btn class="btn btn-sm btn-typo" color="red" href="https://google.com"
          >Decline</v-btn
        >
        <v-btn
          class="btn btn-sm btn-typo"
          color="var(--primary)"
          @click="acceptDisclaimer"
          >Accept</v-btn
        >
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: "DisclaimerPopup",
    data() {
      return {
        visible: false,
      };
    },
    mounted() {
      if (!this.getCookie("disclaimerAccepted")) {
        this.visible = true;
      }
    },
    methods: {
      acceptDisclaimer() {
        this.setCookie("disclaimerAccepted", "true", 365);
        this.visible = false;
      },
      setCookie(name, value, days) {
        const d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
      },
      getCookie(name) {
        const cname = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(";");
        for (let c of ca) {
          c = c.trim();
          if (c.indexOf(cname) === 0) return c.substring(cname.length, c.length);
        }
        return "";
      },
    },
  };
</script>
